import React from 'react';
import { Heart, Mail, Phone, MapPin, Send, Instagram, Facebook, Youtube } from 'lucide-react';

export default function Footer() {
  const whatsappNumber = "+256702601805";
  const emailAddress = "givinghandsministries27@gmail.com";
  
  // Formats the number for the WhatsApp API
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`;

  return (
    <footer className="bg-[#050b1a] text-gray-400 py-20 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        
        {/* Brand & Mission */}
        <div className="space-y-6">
          <div className="flex items-center gap-2">
            <Heart className="text-gh-orange" fill="currentColor" size={24} />
            <span className="text-white font-black text-xl uppercase tracking-tighter">
              Giving <span className="text-gh-orange">Hands</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed">
            A sanctuary for orphans and abandoned children in Mityana, Uganda. 
            We turn vulnerability into purpose through love, education, and 
            sustainable support.
          </p>
          
          {/* Social Links - Fixed ESLint warnings by using real URLs and security attributes */}
          <div className="flex gap-4">
            <a 
              href="https://instagram.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gh-orange hover:text-white transition-all"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a 
              href="https://facebook.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gh-orange hover:text-white transition-all"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </a>
            <a 
              href="https://youtube.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gh-orange hover:text-white transition-all"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Navigation</h4>
          <ul className="space-y-4 text-sm font-medium">
            <li><a href="/" className="hover:text-gh-orange transition-colors">Home</a></li>
            <li><a href="/about" className="hover:text-gh-orange transition-colors">Our Story</a></li>
            <li><a href="/sponsorship" className="hover:text-gh-orange transition-colors">Sponsorship</a></li>
            <li><a href="/vision-trips" className="hover:text-gh-orange transition-colors">Vision Trips</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Get In Touch</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="text-gh-orange shrink-0" size={18} />
              <span>Mityana, Central Region<br />Uganda, East Africa</span>
            </li>
            <li>
              <a href={`mailto:${emailAddress}`} className="flex items-center gap-3 hover:text-white transition-colors">
                <Mail className="text-gh-orange shrink-0" size={18} />
                {emailAddress}
              </a>
            </li>
            <li>
              <a href={`tel:${whatsappNumber}`} className="flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="text-gh-orange shrink-0" size={18} />
                {whatsappNumber}
              </a>
            </li>
          </ul>
        </div>

        {/* Action / WhatsApp Button */}
        <div>
          <h4 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Direct Contact</h4>
          <p className="text-sm mb-6 font-medium">Have questions? Reach out to Ivan directly via WhatsApp.</p>
          
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-[#25D366] text-white font-bold py-4 rounded-xl flex items-center justify-center gap-3 hover:bg-[#128C7E] transition-all shadow-lg shadow-green-900/20"
          >
            CHAT ON WHATSAPP
          </a>
          
          <div className="mt-8 pt-6 border-t border-white/5">
            <p className="text-[10px] uppercase tracking-widest text-gray-500 mb-3 font-black">Newsletter</p>
            <div className="flex bg-white/5 rounded-lg p-1">
              <input 
                type="email" 
                className="bg-transparent border-none px-3 py-2 w-full text-xs outline-none text-white focus:ring-0" 
                placeholder="Email Address"
              />
              <button className="bg-gh-orange text-white p-2 rounded-md hover:scale-105 transition-transform">
                <Send size={14} />
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto border-t border-white/5 mt-20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-[0.2em] font-bold text-gray-500">
        <p>© 2026 Giving Hands Ministry</p>
      </div>
    </footer>
  );
}